export default {
  dayOfMonth: 'Do',
  month: 'MMM',
  dayFullMonthYear: 'D MMMM YYYY',
  dayMonth: 'DD MMM',
  dayMonthYear: 'DD MMM YYYY',
  monthYear: 'MMMM YYYY',
  shortMonthYear: 'MMM YYYY',
  human: 'ddd, D MMMM YYYY',
  humanDayMonth: 'Do of MMMM',
  humanDayMonthYear: 'Do of MMMM YYYY',
  humanShort: 'ddd Do MMM YYYY',
}
